import React from 'react'
import { WrappedFieldProps } from 'redux-form'

// ant
import { Form, Row, Switch } from 'antd'
import { FormItemLabelProps } from 'antd/lib/form/FormItemLabel'
import { SwitchProps } from 'antd/lib/switch'

const { Item } = Form

type Props = WrappedFieldProps & SwitchProps & FormItemLabelProps & {
	confirmChange?: (newChecked: boolean) => boolean
}

const SwitchField = (props: Props) => {
	const {
		input,
		label,
		disabled,
		meta: {
			error,
			touched
		},
		style,
		size,
		onClick,
		checked,
		className,
		confirmChange
	} = props

	const handleChange = (newChecked: boolean) => {
		if (confirmChange && !confirmChange(newChecked)) {
			return
		}
		input.onChange(newChecked)
	}

	return (
		<Item
			label={<span className={'font-semibold'}>{label}</span>}
			help={touched && error}
			validateStatus={(error && touched) ? 'error' : undefined}
			style={style}
			className={className}
		>
			<Row>
				<Switch
					onChange={handleChange}
					checked={(input.value === 'true' || input.value === true) || checked}
					disabled={disabled}
					size={size}
					onClick={onClick}
				/>
			</Row>
		</Item>
	)
}

export default SwitchField
